import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {NestApiProvider} from '../nest-api';
import {responseObj} from '../nest-model/nest-model';
import {Observable} from "rxjs";
import {ResponseData, ResponsePaging} from "../nest-responses";
import {
  RequestBodyGetLeaveBalanceDto,
  RequestParamGetLeaveBalanceDto,
  RequestRemoveLeaveBalanceDto,
  ResponseGetLeaveBalanceDto,
  ResponseRemoveLeaveBalanceDto
} from "./leave-balance.dto";

@Injectable()
export class LeaveBalanceApiProvider {

  private readonly module: string = 'leave';
  private readonly model: string = 'sfGenerateLeaveBalance';

  constructor(
    public http: HttpClient,
    public nestApi: NestApiProvider
  ) {
  }

  generateLeaveBalance(empId: string) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "generateLeaveBalance";
    const params: any = {empId: empId};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  public getLeaveBalance(queryParam: RequestParamGetLeaveBalanceDto, payload: RequestBodyGetLeaveBalanceDto): Observable<ResponsePaging<ResponseGetLeaveBalanceDto>> {
    const method: string = 'POST';
    const func: string = 'getLeaveBalance';
    const params: any = payload || {};
    const urlParams: any = queryParam || {};
    const body: any = {};

    const url = this.nestApi.urlBuilder(method, this.model, func, {}, urlParams, this.module);
    return this.nestApi.request<ResponsePaging<ResponseGetLeaveBalanceDto>>(method, url, params, urlParams, body);
  }

  public removeLeaveBalance(payload: RequestRemoveLeaveBalanceDto): Observable<ResponseData<ResponseRemoveLeaveBalanceDto[]>> {
    const method: string = 'POST';
    const func: string = 'removeLeaveBalance';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApi.urlBuilder(method, this.model, func, {}, urlParams, this.module);
    return this.nestApi.request<ResponseData<ResponseRemoveLeaveBalanceDto[]>>(method, url, params, urlParams, body);
  }

  public deleteLeaveBalance(payload: RequestRemoveLeaveBalanceDto): Observable<ResponseData<ResponseRemoveLeaveBalanceDto[]>> {
    const method: string = 'DELETE';
    const func: string = 'delete-lbm';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApi.urlBuilder(method, this.module, func, {}, urlParams, this.module);
    return this.nestApi.request<ResponseData<ResponseRemoveLeaveBalanceDto[]>>(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/leave/leave-balance-api.ts